import { Grid, makeStyles } from "@material-ui/core";
import PopoverMUI from "@material-ui/core/Popover";

import logo from "../assets/linet_logo_color_rgb.svg";
import usePopoverStyles, { usePopoverStylesWithScrollbar, usePopoverStylesWithNoWidth } from "./popover-styles";
import shim from "../assets/1x1.gif";

const useStyles = makeStyles((theme) => ({
    header: {
        backgroundColor: '#F1F1F0',
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'flex-start',
        padding: '10px 10px',
    },
    title: {
        color: '#000000',
        height: '100px',
        width: '100%',
    },
    titleLogo: {
        width: '100%',
    },
    phoneNumber: {
        fontSize: '25pt',
        color: '#000000',
        fontWeight: '700',
	},
	logo: {
		height: '60px',
		marginLeft: '20px',
		width: 'auto',
	},
	logoShim: {
		width: '2px',
	},
	logoDivider: {
		backgroundColor: '#D0D0CF',
		width: '2px',
		height: '34px',
		marginRight: '20px',
		marginLeft: '0px',
		marginBottom: '3px',

	},
	portalName: {
		color: '#63666A',
		fontFamily: 'GT-America-Expanded',
		textTransform: 'uppercase',
		fontSize: '20pt',
		width: 'auto',
		marginBottom: '3px',
	},
	logoWrapper: {
		display: 'flex',
		flexFlow: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: '100%',
	},
}));
const Popover = ({ onExited, onEscapeKeyDown, showTitle, children, showScrollbar, tall, ignoreWidth, ...props }) => {
    const styleWithoutScrollbars = usePopoverStyles();
    const styleWithScrollbars = usePopoverStylesWithScrollbar();
    const styleWithNoWidth = usePopoverStylesWithNoWidth();
    const classes = ignoreWidth ? styleWithNoWidth : showScrollbar ? styleWithScrollbars : styleWithoutScrollbars;
    const localClasses = useStyles();
    return (
        <PopoverMUI
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
                marginTop: '50px',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            PaperProps={{
                style: { height: '100%' },
            }}
            transitionDuration="auto"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            className={classes.root}
            BackdropProps={{
                classes: {
                    root: classes.backDrop,
                }
            }}
            onExited={onExited}
            onEscapeKeyDown={onEscapeKeyDown}
            {...props}
        >
            <Grid 
                container
                alignItems="flex-start"
                className={tall ? classes.contentTall : classes.content}
                style={(ignoreWidth ? { width: "min-width" } : {}, { height: '100%', alignContent: 'flex-start', flexFlow: 'column nowrap', backgroundColor: '#F1F1F0' })}
            >
                {showTitle && (
                    <Grid
                        className={localClasses.header}
                    >
                        <Grid
								className={localClasses.logoWrapper}
                            >

								<span ><img alt="LINET Rental Portal" src={logo} className={localClasses.logo} /></span>
								<span className={localClasses.logoDivider}>
																<img src={shim} />
								</span>
								<span
									className={localClasses.portalName} variant="body2"
														>
															RENTAL PORTAL
								</span>
                        </Grid>
                    </Grid>
                )}
                {children}
            </Grid>
        </PopoverMUI>
    )
}

export default Popover;